// extracted by mini-css-extract-plugin
export default {"responsive-image":"ResponsiveImage_responsive-image__D9pV4"};